import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import formatter from '../../../../common/helpers/formatter';
import type { FhfMeasure } from '../../../../common/types/client';

type Props = {
  measure: FhfMeasure;
};

function MeasureRow({ measure }: Props) {
  return (
    <Stack flex={1} direction='row' spacing={2} justifyContent='flex-start'>
      <Typography alignSelf='flex-start'>{formatter.formatGermanDate(measure.date)}</Typography>
      <Stack direction='column'>
        <Typography alignSelf='flex-start'>{measure.subject}</Typography>
        <Typography fontSize='0.8rem' alignSelf='flex-start'>
          {measure.advisor}
        </Typography>
      </Stack>
    </Stack>
  );
}

export default MeasureRow;
